var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-full"},[_c('portal',{attrs:{"to":"page-title"}},[_c('div',{staticClass:"flex"},[_c('div',{staticClass:"flex items-center"},[_vm._v("iAM-Platform Home Page")])])]),_c('IntroPage')],1)}
var staticRenderFns = []

export { render, staticRenderFns }